export function formatMetricCost(metrics) {
  if (metrics?.costModel === 'cmu') {
    return metrics.costLabel || 'CMU-based (not per-token)';
  }

  if (typeof metrics?.estimatedCost === 'number' && Number.isFinite(metrics.estimatedCost)) {
    return `$${metrics.estimatedCost.toFixed(6)}`;
  }

  return metrics?.costLabel || 'Cost unavailable';
}
